import { render, staticRenderFns } from "./ParcelBuyerSection.vue?vue&type=template&id=19129560&scoped=true&"
import script from "./ParcelBuyerSection.vue?vue&type=script&lang=js&"
export * from "./ParcelBuyerSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelBuyerSection.vue?vue&type=style&index=0&id=19129560&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19129560",
  null
  
)

export default component.exports